export default __webpack_public_path__ + "static/media/SJA1280.34I-38818_-22734_0.58e7d669.jpg";